import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import "../StickyCta/StickyCta.scss";

const MobileStickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentPath = window.location.pathname;
      if (currentPath === "/agents-win-more-instructions/") {
        setIsVisible(true);
      }
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="mobile-sticky-cta">
      <Link to="https://register.clozesure.com/Agents/Registration" className="btn btn-pink">
        Register with Us
      </Link>
    </div>
  );
};

export default MobileStickyCTA;
